import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  index: {},
};

export const indexSlice = createSlice({
  name: "index",
  initialState,

  reducers: {
    setIndexData: (state, action) => {
      const { item, value, type = "INDEX", date } = action.payload || {};
      if (!item) return;
      if (Array.isArray(state.index)) state.index = {}; // 🛡️
      const timestamp = date ? date.slice(11, 19).replace(/:/g, "_") : "";
      const key = `${item}_${timestamp}`;
      state.index[key] = { item, value, type, date };
    },

    setIndexSent: (state, action) => {
      state.indexSent = action.payload;
    },

    removeIndex: (state, action) => {
      delete state.index[action.payload];
    },

    clearIndex: (state) => {
      state.index = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setIndexData, clearIndex, setIndexSent, removeIndex } = indexSlice.actions;

export default indexSlice.reducer;
